import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gallery18 from "../../../assets/farm/img_22.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        color="#00AEEF"
        fontWeight={900}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        AHAN Consulting
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "42%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          paddingRight={{ xs: "0%", sm: "2%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            AHAN’s consulting team brings over 30 years of experience in
            providing comprehensive consulting services to advance sustainable
            fisheries and aquaculture across Nigeria and Africa. Leveraging deep
            local insights alongside international best practices, the team
            offers tailored guidance, strategic solutions, and hands-on support
            to address the unique challenges of these sectors. AHAN Consulting
            is dedicated to enhancing productivity, sustainability, and
            profitability, equipping clients with practical, science-based
            approaches to drive impactful results in aquaculture and fisheries.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            paddingTop={"4%"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Key Activities:
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>
            Environmental Impact Assessments
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>
            Aquaculture Systems Design and Optimization
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Fisheries Stock Assessment
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Marine and Blue Economy Project Management
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Feasibility Analysis
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Limnological Surveys
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Regulatory Compliance and Policy Guidance
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Resource Conservation Strategies
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Process Architecture Designs
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            paddingTop={"4%"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            This approach underlines AHAN&#39;s deep technical experience,
            practical solutions, and commitment to sustainable development.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "650px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={gallery18}
            alt={"farm-services-img"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
